import {Injectable} from '@angular/core';
import {IGridStatus} from '../../../ap-interface/interfaces/ap-grid-status.interface';
import IJobs = Data.Job.IJobs;

@Injectable({ providedIn: 'root' })
export class JobsService {
  public getStatus(job: IJobs): IGridStatus {
    let descriptionState: string;
    let classState: string;
    if (job.Status === 2 || job.Status === 1) {
      classState = job.Status === 2 ? 'ap-status-green' : 'ap-status-green-autumn-scan';
      descriptionState = 'Global__ProcessSuccessful';
    } else if (job.Status === 0) {
      classState = 'ap-status-grey';
      descriptionState = 'Global__ProcessWaiting';
    } else if (job.Status === -1) {
      classState = 'ap-status-red';
      descriptionState = 'Global__ProcessFailed';
    } else {
      classState = 'ap-status-yellow';
      descriptionState = 'Data_RuleResult__Processing';
    }
    return {
      state: job.Status,
      class: classState,
      description: descriptionState
    };
  }
}
